import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TpAutoFormChoice, TpAutoFormChoiceIcon } from './AutoForm';
import styles from './AutoForm.module.scss';

interface TpPickListProps {
  choices: TpAutoFormChoice[];
  selected: string;
  setSelected: (newId: string) => void;
  disableTransparentBackground?: boolean;
}

export function PickList({ choices, selected, setSelected, disableTransparentBackground }: TpPickListProps) {
  const getChoiceIcons = (choice: TpAutoFormChoice): TpAutoFormChoiceIcon[] => {
    if (choice.icons && choice.icons.length > 0) {
      return choice.icons;
    }
    if (choice.iconName) {
      let prefix = choice.iconPrefix || 'fas';
      let name = choice.iconName;
      if (name.includes(':')) {
        const parts = name.split(':');
        prefix = parts[0] as 'fas' | 'far';
        name = parts[1];
      }
      return [{ iconName: name, iconPrefix: prefix, title: undefined }];
    }
    return [];
  };

  return (
    <div className={disableTransparentBackground ? styles.pickList : styles.pickListTransparent}>
      {choices.map((choice) => {
        const icons = getChoiceIcons(choice);
        return (
          <div
            key={choice.id}
            title={choice.title}
            className={
              choice.id == selected
                ? disableTransparentBackground
                  ? styles.pickListItemSelected
                  : styles.pickListItemSelectedTransparent
                : disableTransparentBackground
                  ? styles.pickListItem
                  : styles.pickListItemTransparent
            }
            onClick={() => {
              setSelected(choice.id);
            }}
          >
            <span className={styles.pickListItemContent}>{choice.content}</span>
            {icons.length > 0 && (
              <span className={styles.pickListItemIconGroup}>
                {icons.map((icon, idx) => (
                  <FontAwesomeIcon
                    key={`${icon.iconName}-${idx}`}
                    icon={[icon.iconPrefix || 'fas', icon.iconName as any]}
                    className={styles.pickListItemIcon}
                    title={icon.title}
                  />
                ))}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}
